/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Archival_Results_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Only the International Coordinator can correct an archival record" |
*
* @param {Err_Tournament_Archival_Results_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_archival_results_forbidden = /** @type {((inputs?: Err_Tournament_Archival_Results_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Archival_Results_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seul le Coordinateur International peut corriger un enregistrement d'archive")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo el Coordinador Internacional puede corregir un registro de archivo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente o Coordenador Internacional pode corrigir um registro de arquivo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo il Coordinatore Internazionale può correggere una registrazione d'archivio")
	return /** @type {LocalizedString} */ ("Only the International Coordinator can correct an archival record")
});